import AuthContextProvider from './authContext/AuthContextProvider';
import DashboardContextProvider from './dashboardContext/DashboardContextProvider';
import UserContextProvider from './userContext/UserContextProvider';
import AccessContextProvider from './accessContext/AccessContextProvider';
import ProductContextProvider from './productContext/ProductContextProvider';
import CustomerContextProvider from './customerContext/CustomerContextProvider';
import RoleContextProvider from './roleContext/RoleContextProvider';
import ProductGroupContextProvider from './ProductGroupContext/ProductGroupContextProvider';
import ServiceContextProvider from './serviceContext/ServiceContextProvider';
import TermsAndConditionContextProvider from './termsAndConditionContext/TermsAndConditionContextProvider';
import AlternateProductContextProvider from './alternateProductContext/AlternateProductContextProvider';
import OfferContextProvider from './offersContext/OfferContextProvider';
import ProposalContextProvider from './proposalContext/ProposalContextProvider';
import MarginCalculatorContextProvider from './marginCalculatorContext/MarginCalculatorContextProvider';
import AccountFormContextProvider from './accountFormContext/AccountFormContextProvider';
import EstimatedArrivalContextProvider from './estimatedArrival/EstimatedArrivalContextProvider';
import FiscalYearContextProvider from './FiscalYearContext/FiscalYearContextProvider';
import SalesFileContextProvider from './salesFileContext/SalesFileContextProvider';
import AccountConsolidationContextProvider from './accountConsolidationContext/accountConsolidationContextProvider';
import BiCustomerContextProvider from './biCustomerContext/BiCustomerContextProvider';
import PaymentReminderContextProvider from './paymentReminderContext/PaymentReminderContextProvider';
import BtsContextProvider from './btsContext/BtsContextProvider';
import MinMaxContextProvider from './minMaxContext/MinMaxContextProvider';

const providers = [
  AuthContextProvider,
  DashboardContextProvider,
  UserContextProvider,
  AccessContextProvider,
  ProductContextProvider,
  CustomerContextProvider,
  RoleContextProvider,
  ProductGroupContextProvider,
  ServiceContextProvider,
  TermsAndConditionContextProvider,
  AlternateProductContextProvider,
  OfferContextProvider,
  ProposalContextProvider,
  MarginCalculatorContextProvider,
  AccountFormContextProvider,
  EstimatedArrivalContextProvider,
  FiscalYearContextProvider,
  SalesFileContextProvider,
  AccountConsolidationContextProvider,
  BiCustomerContextProvider,
  PaymentReminderContextProvider,
  BtsContextProvider,
  MinMaxContextProvider,
];

export default providers;
